import AxiosDefault from "services/AxiosDefault";

export const getActivityLogsAPI = async ({
  page,
  limit,
  searchTerm,
  targetType,
  filterModel,
  sortModel,
}) => {
  const response = await AxiosDefault({
    method: "POST",
    url: "/user/logs/get",
    data: { page, limit, searchTerm, targetType, filterModel, sortModel },
  });
  return response.data;
};
